"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "WelcomeRegistration" };
var _hoisted_2 = /*#__PURE__*/ vue_2.createElementVNode("h2", { class: "heading2" }, "Тип пользователя", -1);
var _hoisted_3 = { class: "button-tabs-container" };
var _hoisted_4 = /*#__PURE__*/ vue_2.createElementVNode("div", { class: "button-tabs__icon" }, [
    /*#__PURE__*/ vue_2.createElementVNode("i", { class: "termi-user-business" })
], -1);
var _hoisted_5 = /*#__PURE__*/ vue_2.createElementVNode("div", null, "Частное лицо", -1);
var _hoisted_6 = [
    _hoisted_4,
    _hoisted_5
];
var _hoisted_7 = /*#__PURE__*/ vue_2.createElementVNode("div", { class: "button-tabs__icon" }, [
    /*#__PURE__*/ vue_2.createElementVNode("i", { class: "termi-briefcase" })
], -1);
var _hoisted_8 = /*#__PURE__*/ vue_2.createElementVNode("div", null, "Организация", -1);
var _hoisted_9 = [
    _hoisted_7,
    _hoisted_8
];
var vue_3 = require("vue");
var vuex_1 = require("vuex");
var registrationFiz_vue_1 = require("./registrationFiz.vue");
var registrationOrg_vue_1 = require("./registrationOrg.vue");
var axios_1 = require("axios");
exports.default = vue_1.defineComponent({
    setup: function (__props) {
        var tab = vue_3.ref('fiz');
        function changeTab(s) {
            tab.value = s;
        }
        var store = vuex_1.useStore();
        function register(_a) {
            var formData = _a.formData, errors = _a.errors;
            return __awaiter(this, void 0, void 0, function () {
                var res, err, error_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, axios_1.default.post('/registration/', formData)];
                        case 1:
                            res = _b.sent();
                            err = res.data.errors;
                            if (Array.isArray(err)) {
                                err.forEach(function (i) { return errors.push(JSON.stringify(i)); });
                                throw err;
                            }
                            store.dispatch('getData');
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _b.sent();
                            console.error(error_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        return function (_ctx, _cache) {
            return (vue_2.openBlock(), vue_2.createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                vue_2.createElementVNode("div", _hoisted_3, [
                    vue_2.createElementVNode("div", {
                        class: vue_2.normalizeClass(["button-tabs", { 'toggled': tab.value === 'fiz' }]),
                        onClick: _cache[0] || (_cache[0] = function ($event) { return (changeTab('fiz')); })
                    }, _hoisted_6, 2),
                    vue_2.createElementVNode("div", {
                        class: vue_2.normalizeClass(["button-tabs", { 'toggled': tab.value === 'org' }]),
                        onClick: _cache[1] || (_cache[1] = function ($event) { return (changeTab('org')); })
                    }, _hoisted_9, 2)
                ]),
                (tab.value === 'fiz')
                    ? (vue_2.openBlock(), vue_2.createBlock(registrationFiz_vue_1.default, {
                        key: 0,
                        onSendForm: register
                    }))
                    : (vue_2.openBlock(), vue_2.createBlock(registrationOrg_vue_1.default, {
                        key: 1,
                        onSendForm: register
                    }))
            ]));
        };
    }
});
